import { Component, OnInit } from '@angular/core';
import { WorkflowWizardService } from 'app/services/workflow-wizard.service';
import { Router } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { EcoDocsTitleService } from 'app/services/ecodocs-title.service';

@Component({
  selector: 'app-workflow-rules',
  templateUrl: './workflow-rules.component.html',
  styleUrls: ['./workflow-rules.component.scss']
})
export class WorkflowRulesComponent implements OnInit {

  constructor(public workflowWizardService: WorkflowWizardService, private _route: Router, private ecoDocsTitleService: EcoDocsTitleService) { 
  }

  ngOnInit() {
    this.ecoDocsTitleService.setTitle( 'Workflow Wizard > Auto-Actions', false );

    if(this.workflowWizardService.currentId == 'new' && this.workflowWizardService.currentStepURL != this.workflowWizardService.WIZARD_THIRD_STEP) {
      this._route.navigate([this.workflowWizardService.baseURL + this.workflowWizardService.WIZARD_FIRST_STEP]) 
    }
  }

  onClickNext() {
    let initialCompletion: FormGroup = this.workflowWizardService.workflowTemplateFormGroup.controls['initial_step_completion'] as FormGroup;
    
    if (initialCompletion.controls['next_step']  && initialCompletion.controls['next_step'].value && this.workflowWizardService.workflowType != 'custom') {
      this.workflowWizardService.currentStep = initialCompletion.controls['next_step'] as FormGroup;
      this.workflowWizardService.currentStepURL = this.workflowWizardService.WIZARD_NEW_STEP;
      this._route.navigate([`${this.workflowWizardService.baseURL}${this.workflowWizardService.WIZARD_NEW_STEP}`]);
    }
    else if (this.workflowWizardService.workflowType == 'custom') {
      this.workflowWizardService.currentStepURL = this.workflowWizardService.WIZARD_STEPS_TREE;
      this._route.navigate([`${this.workflowWizardService.baseURL}${this.workflowWizardService.WIZARD_STEPS_TREE}`]);
    }
    else {
      this.workflowWizardService.saveWorkflowTemplate().subscribe(()=>{
        this._route.navigate(['workflows/templates']);
      });
    }  
  }

  saveAndPublish() {
    this.workflowWizardService.saveWorkflowTemplate().subscribe(()=>{
      this.workflowWizardService.publishWorkflowTemplate().subscribe(()=>{
        this._route.navigate(['workflows/templates']);
      });
    });
  }

  back() {
    this.workflowWizardService.currentStepURL = this.workflowWizardService.WIZARD_SECOND_STEP;
    this._route.navigate([`${this.workflowWizardService.baseURL}${this.workflowWizardService.WIZARD_SECOND_STEP}`]);
  }
}
